// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__15j4c","loginLink":"Header_loginLink__3AENj","centerElement":"Header_centerElement__1uN9x"};